module.exports = __webpack_public_path__ + "img/pictoPeople6.8622a1d7.svg";